// extracted by mini-css-extract-plugin
export default {"ace-c-invoice-line-modal":"invoice-line-data-modal---7184b878"};